<template>
    <div class="transcript">
        <div class="transcript-single">
            <div class="section-block upload-block">
                <div class="section-title">案件笔录</div>
              <div class="tip"><i class="el-icon-warning-outline"></i>说明：选择笔录类型后系统会自动生成笔录模板，您可以根据需要编辑内容。上传文件将自动保存为txt格式。
              </div>
                    <el-form ref="formRef" :model="form" :rules="formRules" label-width="140px" class="section-form">
                      <el-row :gutter="20">
                          <el-col :span="12">
                            <el-form-item label="笔录类型" prop="typeCode">
                              <el-select
                                  v-model="form.typeCode"
                                  placeholder="请选择笔录类型"
                                  clearable
                                  style="width: 100%;"
                              >
                                <el-option
                                    v-for="item in transcriptTypeOptions"
                                    :key="item.dictValue"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                />
                              </el-select>
                            </el-form-item>
<!--                            <el-form-item label="生成笔录内容" prop="transcriptContent">-->
<!--                              <el-input-->
<!--                                  v-model="form.transcriptContent"-->
<!--                                  type="textarea"-->
<!--                                  placeholder="请输入生成笔录内容"-->
<!--                                  clearable-->
<!--                                  style="width: 100%;"-->
<!--                                  :rows="6"-->
<!--                                  />-->
<!--                              请根据实际情况编辑笔录内容-->
<!--                            </el-form-item>-->
                            <el-form-item label="备注说明" prop="descr">
                              <el-input
                                  v-model="form.descr"
                                  type="textarea"
                                  :rows="4"
                                  placeholder="请输入备注说明"
                                  resize="vertical"
                              />
                            </el-form-item>
                            <el-form-item>
                              <el-button type="primary" :loading="saveLoading" @click="handleSave" v-if="step2Status!=2">保存笔录信息</el-button>
                            </el-form-item>
                          </el-col>
                        <el-col :span="12">
                          <el-form-item label="上传笔录文件" prop="file">
                            <el-upload class="transcript-upload" action :show-file-list="false" :http-request="enclosure" >
                              <div class="upload-inner">
                                <i class="el-icon-fake custom-icon icon-uploadfile" ></i>
                                <div class="upload-text">点击上传笔录文件（自动保存为txt）</div>
                                <div class="el-upload__tip">
                                  支持 .txt, .doc, .docx 格式
                                </div>
                              </div>
                            </el-upload>
                            <ul class="upload-list">
                              <li v-for="(file, index) in form.file" class="upload-list-li">
                                <a class="upload-list-li-name"><i class="el-icon-paperclip" aria-hidden="true"></i>{{ file.name }}</a>
                                <label class="upload-list-li-label" @click="handleRemove(index)">
                                  <i class="el-icon-plus"></i></label>
                              </li>
                            </ul>

                          </el-form-item>
                        </el-col>
                      </el-row>

<!--                        <el-form-item label="被调查人" prop="respondentName">-->
<!--                            <el-input-->
<!--                                v-model="form.respondentName"-->
<!--                                placeholder="请输入被调查人"-->
<!--                                clearable-->
<!--                                style="width: 100%;"-->
<!--                            />-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="调查时间" prop="surveyTime">-->
<!--                            <el-date-picker-->
<!--                                v-model="form.surveyTime"-->
<!--                                type="datetime"-->
<!--                                placeholder="请选择调查时间"-->
<!--                                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                                style="width: 100%;"-->
<!--                            />-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="调查地点" prop="surveyAddress">-->
<!--                            <el-input-->
<!--                                v-model="form.surveyAddress"-->
<!--                                placeholder="请输入调查地点"-->
<!--                                clearable-->
<!--                                style="width: 100%;"-->
<!--                            />-->
<!--                        </el-form-item>-->
                    </el-form>
                </div>
        </div>
    </div>
</template>

<script>
import { uploadFile } from '@/api/upload/upload'
import { getListByDictType } from '@/api/sys/dictData'
import {addTranscriptRecord} from '@/api/recognition/survey'
export default {
    name: 'Transcript',
  props:{
    step2Status:{
      type:Number,
      default:null
    }
  },
    data() {
        return {
            form: {
              typeCode: '',
                respondentName: '',
                surveyTime: '',
                surveyAddress: '',
                file: [],
                descr: '',
              typeName: ''
            },
            formRules: {
                file: [{ required: true, message: '请选择要上传的文件', trigger: 'change' }],
              typeCode: [{ required: true, message: '请选择笔录类型', trigger: 'change' }],
                respondentName: [{ required: true, message: '请输入被调查人', trigger: 'blur' }],
                surveyTime: [{ required: true, message: '请选择调查时间', trigger: 'change' }],
            },
            transcriptTypeOptions: [],
            saveLoading: false
        }
    },
    created() {
        this.loadDictData()
    },
    methods: {
        async loadDictData() {
            try {
                const res = await getListByDictType('industrial_injury_transcript_type')
                if (res && res.code === 200 && res.data) {
                    this.transcriptTypeOptions = res.data
                }
            } catch (e) {
                console.warn('字典 transcript_type 加载失败', e)
            }
        },
        handleFileChange(file) {
            this.form.file = file?.raw || null
        },
        async handleSave() {
          this.$refs.formRef.validate((valid)=>{
            if (!valid) {
                return
            }
            let params = {
                ...this.form
            }
            this.saveLoading = true
            params.fileUrl = params.file.map(item => item.url).join(',')
            params.caseId = this.$route.query.id || ''
            params.typeName=this.selectDictLabel(this.transcriptTypeOptions, params.typeCode)
            delete params.file
            addTranscriptRecord(params).then(res=>{
                if (res.code === 200) {
                    this.$message.success('保存笔录信息成功')
                    this.resetForm()
                } else {
                    this.$message.error(res?.msg || '保存失败')
                }
            }).finally(()=>{
                this.saveLoading = false
            })
          })
        },
        resetForm() {
            this.form.typeCode = ''
            this.form.respondentName = ''
            this.form.surveyTime = ''
            this.form.surveyAddress = ''
            this.form.file = []
            this.form.descr = ''
            this.$refs.uploadRef?.clearFiles()
            this.$refs.formRef?.clearValidate()
            this.form.typeName = ''
        },
      // 附件上传
      enclosure({
                  file
                }) {
        var that = this;
        const formdata = new FormData();
        formdata.append("file", file);
        formdata.append("type", "ajbl");
        uploadFile(formdata).then((res) => {
          if (res.code == 200) {
            var obj = {};
            obj.url = res.data.url;
            obj.name = res.data.originName;
            that.form.file = that.form.file.concat(obj);
          }
        });
      },
      // 上传之前校验
      beforeAvatarUpload(file) {
        // const isJPG = file.type === "image/jpeg";
        const isLt10M = file.size / 1024 / 1024 < 10;

        // if (!isJPG) {
        //   this.$message.error("上传头像图片只能是 JPG 格式!");
        // }
        if (!isLt10M) {
          this.$message.error("上传附件大小不能超过 10MB!");
        }
        // return isJPG && isLt2M;
        return isLt10M;
      },
      // 附件删除
      handleRemove(index) {
        this.form.file.splice(index, 1)
      },
    }
}
</script>

<style lang="scss" scoped>
.transcript {
    width: 100%;
    height: 100%;
}

.transcript-single {
   flex: 1;
}

.section-block {
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 0;

    .section-title {
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    padding-left: 11px;
    margin-bottom: 12px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 12px;
        border-radius: 20px;
        background: var(--vt-c-blue);
    }
}
}

.upload-block {
    min-height: 320px;
}

.section-form {
    max-width: 100%;
}

.transcript-upload {
    display: block;

    :deep(.el-upload) {
        display: block;
        width: 100%;
    }
}

.upload-inner {
    width: 100%;
    min-height: 120px;
    border: 1px dashed #c0c4cc;
    border-radius: 4px;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;

    &:hover {
        border-color: var(--el-color-primary-light-5);
        background: #f0f9ff;
    }
}

.upload-icon {
    font-size: 40px;
    color: #c0c4cc;
    margin-bottom: 8px;
}

.upload-inner:hover .upload-icon {
    color: var(--el-color-primary);
}

.upload-text {
    font-size: 14px;
    color: #606266;
}

.file-name {
    margin-top: 8px;
    font-size: 13px;
    color: #606266;
}
.upload-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.upload-list-li {
  position: relative;
  margin-top: 5px;
  line-height: 1.8;
}

.upload-list-li:hover {
  background-color: #f5f7fa;
}

.upload-list-li-name {
  position: relative;
  margin-right: 40px;
  display: block;
  color: black;
}

.fa-file-text-o {
  margin-right: 7px;
}

.upload-list-li-label {
  position: absolute;
  right: 5px;
  top: 0;

  i {
    transform: rotate(45deg);
  }
}

.file-box {
  padding: 5px 15px;
  border-radius: 3px;
  background-color: #409eff;
  border-color: #409eff;
  color: #000;
  display: inline-block;
  position: relative;
}

.file-btn {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  outline: none;
  background-color: transparent;
  filter: alpha(opacity=0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
}
.tip {
  height: 44px;
  display: flex;
  place-content: center;
  place-items: center;
  gap: 10px;
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 4px;
  background: rgba(254, 237, 238, 1);
  color: rgba(255, 62, 80, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 10%;
  margin-bottom: 24px;
}
</style>
